import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=0873aa6e&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=0873aa6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873aa6e",
  null
  
)

export default component.exports